import React from "react";

import { Button, Description, SubTitle } from "Components/CustomComponents";
import styles from "./styles/ProfileCard.module.scss";
import { useNavigate } from "react-router-dom";
import { WEB_ROUTES } from "../../constants";
import { Drivers } from "Data/interfaces";

interface ProfileCardProps {
  driver: Drivers;
  routeId: number;
}

const ProfileCard: React.FC<ProfileCardProps> = ({ driver, routeId }) => {
  // console.log(driver);
  // console.log(routeId);
  const navigate = useNavigate();

  const handleLogClick = () => {
    navigate(WEB_ROUTES.ROUTE_TRACKING(routeId));
  };

  return (
    <div className={styles.ProfileCard}>
      <div className="w-100 d-flex flex-row align-items-center gap-3">
        <img src={driver.image_url} className={styles.image} alt="" />
        <div className={`${styles.content} d-flex flex-row align-items-center`}>
          <div className={`d-flex flex-column`}>
            <SubTitle
              text={`${driver.firstname} ${driver.lastname}`}
              classes="mb-05 lc-1"
            />
            <Description
              text={
                <>
                  Truck No: <span className="fw-bold">{driver.truck_no}</span>
                </>
              }
            />
          </div>
        </div>
      </div>
      <Button
        text="Activities Log"
        isOutlined={true}
        classes={`${styles.button} fs-7`}
        onClick={handleLogClick}
      />
    </div>
  );
};

export default ProfileCard;
